import { useDispatch, useSelector } from 'react-redux'

import { Themes, themes, CustomTheme } from '@masfront/common-b2c'

import { changeTheme } from './store/theme.reducer'
import { selectTheme } from './store/theme.selectors'

interface useTheme {
  setTheme: (actualTheme: string) => void
  theme: CustomTheme
}

function useTheme(): useTheme {
  const dispatch = useDispatch()
  const theme = useSelector(selectTheme)

  function setTheme(actualTheme: string): void {
    const newTheme = actualTheme as keyof typeof Themes
    dispatch(changeTheme(Themes[newTheme]))
  }

  return {
    setTheme,
    theme: themes[theme],
  }
}

export default useTheme
